  export enum UserInfoStoreError {
    GET_USER_INFO = "Error getting user information",
    GET_CURRENT_USER_INFO = "Error getting user information",
    GET_ALL_NOTIFICATION_GROUPS = "Error getting available notification groups",
    GET_USER_NOTIFICATION_GROUPS = "Error getting notification groups",
    GET_USER_NOTIFICATION_PREFS = "Error getting notification preferences",
    UPDATE_USER_NOTIFICATION_PREFS = "Error updating notification preferences",
    UPDATE_USER_PROFILE = "Error updating profile",
    GET_USER_PREFERENCES = "Error getting preferences",
    UPDATE_USER_PREFERENCES = "Error saving preferences",
  }
  
  export enum UserInfoStoreSuccess {
    UPDATE_USER_NOTIFICATION_PREFS = "Successfully updated notification preferences",
    UPDATE_USER_PROFILE = "Successfully updated profile",
  }
  